<template>
	<AuthLayout title="Forgot password">
		<div class="list-group-item p-4">
			<form @submit.prevent="forgot">
				<div class="form-group">
					<input
						class="form-control"
						placeholder="email"
						required
						type="email"
						v-model="email"
					>
				</div>
				<div class="d-flex justify-content-between mt-5">
					<router-link
						class="btn btn-outline-primary"
						to="/login"
					>&laquo; Log in</router-link>
					<button
						class="btn btn-primary"
						type="submit"
					>Request new password</button>
				</div>
			</form>
		</div>
	</AuthLayout>
</template>

<script>
import AuthLayout from '@/layouts/AuthLayout.vue'
import auth from '@/auth'

export default {
	components: { AuthLayout },
	data() {
		return {
			email: null,
		}
	},
	methods: {
		async forgot() {
			auth.resetAuthMessages()
			const { email } = this
			this.sharedState.loading = true
			try {
				await auth.submitForgotForm(email)
				this.email = null
				this.sharedState.authSuccess =
					'An email has been sent to you with instructions on how to set a new password.'
				this.$router.push('/login')
			} catch (error) {
				this.sharedState.authError = error
			} finally {
				this.sharedState.loading = false
			}
		},
	},
	beforeRouteEnter(to, from, next) {
		auth.resetAuthMessages()
		next()
	},
}
</script>
